import React from "react";

export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="px-10 pt-10 pb-0 bg-surface">
      <div className="flex items-center justify-between gap-4">
        <div className="border-l-[3px] border-[#274f38] pl-4">
          <h1 className="text-3xl md:text-4xl font-medium tracking-tight" style={{ fontFamily: "Outfit" }}>{title}</h1>
          {subtitle && <p className="text-[#586960] text-sm mt-1">{subtitle}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      <hr className="border-[#E3DFD5] mt-6" />
    </div>
  );
}
